// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__311lD","select":"Header_select__2XhZU","clinic":"Header_clinic__2LFwO"};